import { IWeeklySessionsData } from 'model/v2/providerCapacity';

/**
 * The weekly session target to show for a provider: the stored weekly limit
 * when it is above zero, otherwise the care sessions on their template.
 *
 * Every screen that shows "booked / target" goes through here, so a provider
 * with no limit reads against their template rather than "1/0".
 */
export const effectiveTargetSessions = (
  stored?: IWeeklySessionsData | null,
  template?: IWeeklySessionsData | null
): IWeeklySessionsData | undefined => {
  if (Number(stored?.total) > 0) return stored as IWeeklySessionsData;
  if (Number(template?.total) > 0) return template as IWeeklySessionsData;
  return stored ?? undefined;
};
